//toastify
import 'react-toastify/dist/ReactToastify.css';

// scroll bar

import 'simplebar/src/simplebar.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ToastContainer } from 'react-toastify';
import Providers from './contexts/Providers';
import Error from './components/Error';

// ----------------------------------------------------------------------

ReactDOM.render(
  <Providers>
    <BrowserRouter>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
      />
      <Error>
        <App />
      </Error>
    </BrowserRouter>
  </Providers>,
  document.getElementById('root'),
);
